import { IProductResponse, ProductFormValues } from '../../types/product';

export const mapProductResponseToForm = (
  response: IProductResponse
): ProductFormValues => ({
  // Identificación
  id: response.id,
  code: response.code,
  name: response.name,
  description: response.description,

  // Precios
  price: response.price,
  cost: response.cost,
  minimumSalePrice: response.minimumSalePrice ?? null,

  // Inventario
  stock: response.stock,
  status: response.status,
  tipEligible: response.tipEligible ?? false,
  appliesTourismTax: response.appliesTourismTax ?? false,
  stockControlEnabled: response.stockControlEnabled ?? false,
  appliesDiscount: response.appliesDiscount ?? true,

  // Catálogos
  categoryId: response.category?.id ?? null,
  categoryName: response.category?.name ?? '',

  unitId: response.unit?.id ?? null,
  unitName: response.unit?.name ?? '',

  itemTypeId: response.itemType?.id ?? null,
  itemTypeDescription: response.itemType?.description ?? '',
  itemTypeCode: response.itemType?.code ?? null,

  // Identificadores externos
  barcode: response.barcode ?? null,
  sku: response.sku ?? null,
  manufacturerCode: response.manufacturerCode ?? null,
  searchCode: response.searchCode ?? null,

  // Clasificación
  brandId: response.brand?.id ?? null,
  brandName: response.brand?.name ?? '',

  subCategoryId: response.subCategory?.id ?? null,
  subCategoryName: response.subCategory?.name ?? '',

  // Trazabilidad
  lotNumber: response.lotNumber ?? null,
  batch: response.batch ?? null,
  expirationDate: response.expirationDate ?? null, // ISO string

  // Variantes
  colorId: response.color?.id ?? null,
  colorName: response.color?.name ?? null,
  sizeId: response.productSize?.id ?? null,
  sizeName: response.productSize?.name ?? null,
  variant: response.variant ?? null,

  // Consumible
  consumable: response.consumable ?? null,

  // Dimensiones
  weight: response.weight ?? null,
  height: response.height ?? null,
  width: response.width ?? null,
  length: response.length ?? null,

  // Condiciones especiales
  humiditySensitive: response.humiditySensitive ?? null,
  coldChain: response.coldChain ?? null,

  // Ubicación física en almacén
  storageLocationId: response.storageLocation?.id ?? null,
  storageAisle: response.storageLocation?.aisle ?? null,
  storageRow: response.storageLocation?.row ?? null,
  storageShelf: response.storageLocation?.shelf ?? null,
  storageBin: response.storageLocation?.bin ?? null,

  // Imagen
  imagePath: response.imagePath ?? undefined,
  imageUrl: response.imagePath || '',
  file: undefined,
});
